import { createModal } from '@tf/ui';

import { AddApplicationForm } from './AddApplicationForm';

export const AddApplicationModal = createModal<{ onClose: () => void }>(({ onClose }) => {
	return <AddApplicationForm isInModal onClose={onClose} />;
});
